import React from "react";
import { useParams } from "react-router-dom";
import { TrendingPackages } from "../../utils/package";
import { DestinationsData } from "../../utils/destinations";
import Card from "../../components/Card/Card";

const DestPackages = () => {
  const { dest } = useParams<{ dest: string }>();

  
  
  const packageInfo = DestinationsData.find((pkg) => pkg.slug === dest);
  const filteredPackages = TrendingPackages.filter((pkg) => pkg.slug === dest);
  console.log(dest, filteredPackages, packageInfo);

  return (
    <div className="bg-black text-white ">
      <div className="relative w-full h-[200px] lg:h-[400px]">
        <img
          src={packageInfo?.image?.src}
          alt={packageInfo?.image?.alt || "pic"}
          className="object-cover w-full h-full opacity-80"
        />
        <div className="absolute inset-0 flex items-center justify-center px-4 bg-black/50">
          <h1 className="text-2xl lg:text-4xl font-bold text-white drop-shadow-lg">
            {packageInfo?.title}
          </h1>
        </div>
      </div>

      {/* Package Details Section */}
      <div className="container mt-20 ">
        <div className="grid lg:grid-cols-3 gap-8 md:grid-cols-2 grid-cols-1 mx-4 lg:mx-0 ">
          {filteredPackages.map((item, index) => (
            <div className="flex justify-center items-center">
              <Card data={item} key={index} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DestPackages;
